import { useRouteError, ErrorResponse } from "react-router-dom";
import ErrorDisplay, { Props } from "@/components/ErrorDisplay";

export default function ErrorPage({ status, statusText, ...rest }: Props) {
  const error = useRouteError() as ErrorResponse | undefined;
  return (
    <ErrorDisplay
      status={status ?? error?.status}
      statusText={statusText ?? error?.statusText}
      {...rest}
    />
  );
}
